import {ChangeDetectorRef, Component, EventEmitter, forwardRef, Output} from "@angular/core";
import {FormBuilder, FormControl} from "@angular/forms";
import {PropertyService} from "../../../services/property-service/property.service";
import {AbstractVisbosControl} from "../../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {Property} from "../../../../shared/view-model/core/property.type";

@Component({
  selector: 'vb-property-type-selection',
  templateUrl: './property-type-selection.component.html',
  styleUrls: ['./property-type-selection.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => PropertyTypeSelectionComponent)}]
})
export class PropertyTypeSelectionComponent extends AbstractVisbosControl<Property, FormControl> {

  //@HostBinding('class.form-control')

  propertyTypes = [];

  @Output()
  propertySelected: EventEmitter<Property> = new EventEmitter<Property>();

  constructor(fb: FormBuilder, cd: ChangeDetectorRef,
              private propService?: PropertyService) {
    super(fb, cd, null);
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.propService) {
      this.propService.getPropertiesList().subscribe((properties) => {
        this.propertyTypes = properties;
      })
    }
  }

  buildControlContent(values?: Property): FormControl {
    return PropertyTypeSelectionComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormControl {
    return fb.control(null);
  }

  public setDefaultValues(item?: Property): {[controlKey: string]: any} | any {
    return this.setValue(item, 'cuid');
  }

  selectPropertyType(property: Property) {
    //this.item = !isUndefined(property) ? property : this.item;
    this.propertySelected.emit(property);
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stock-item/stock-item-property/property-type-selection/property-type-selection.component.ts